import { render, staticRenderFns } from "./umPreviewImg.vue?vue&type=template&id=4d52c34b&"
import script from "./umPreviewImg.vue?vue&type=script&lang=js&"
export * from "./umPreviewImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports